export const PUBLIC_PEM = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAot8Dk88zYRHEq7NKmomA
4nwgjojXkjqvlh7EsWus5tuh5wWqgWDR1PCUoLVnyjepQfZ4IkBGXPzoBHX2ee6c
qz1YEBKKmeKkTHUQh2K9a+Y0TBshSX0p3W2BXmMr53fP8vy1SgAm99Fo3Zyb22mG
vYc2EonrXaePTuM6x7Wlp8tdaYtd815PCzH9eFsAddM8bSIv+EDibomkNY6FvjAA
5+FqM35KrFwVJZwZMmM+k8nJcgadKGj4nv4v47Mbx6bsIa8oqDd+eKt9Sp/tHbbN
Rb3Bz1b0zW6gSljom52bAGQ/fCeez3mEEax2P56ZXyRGYJWCWuYQ2QOXRcNTpSnU
IwIDAQAB
-----END PUBLIC KEY-----
`;
